module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_null@2x.6303f599.png";